// Parser minimo para el unico marcador de Markdown que usamos en texto
// generado por el backend (tips, respuestas del chat): **negrita**.
// No es un parser de Markdown completo a proposito -- el contenido fuente
// (consejos_auxilio.md, prompts del chatbot) solo usa este marcador.
export function renderBold(text, keyPrefix = 'bold') {
  if (!text) return text;
  const regex = /\*\*(.+?)\*\*/g;
  const parts = [];
  let lastIdx = 0;
  let match;
  let i = 0;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIdx) parts.push(text.slice(lastIdx, match.index));
    parts.push(<strong key={`${keyPrefix}-${i++}`}>{match[1]}</strong>);
    lastIdx = match.index + match[0].length;
  }
  if (lastIdx < text.length) parts.push(text.slice(lastIdx));
  return parts.length ? parts : text;
}
